var _filter, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 417.14 329.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#251460",
    floodOpacity: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.32,139.35c2.54-4.98-9.19-16.03-26.19-24.69-17-8.66-32.84-11.65-35.37-6.68l-11.19,21.49,61.57,31.37,10.5-20.6c.29-.26.52-.56.69-.89Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.44,86.2c-3.96-5.95-23.66.19-44,13.73-20.34,13.53-33.61,29.33-29.65,35.28l16.96,25.97,73.65-49.01-16.4-24.64c-.11-.48-.3-.93-.56-1.33Z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#drop-shadow-1)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.29,345.12l-84.58-85.3c-2.55-2.57-3.84-6.14-3.53-9.75l2.72-31.6c.04-2.33-1.23-4.4-3.56-4.44-3.42-.06-4.63,3.14-5,5.3,0,0-.6,8.24-3.46,13.41-1.66,3-7.16,5.27-12.4-.99l-19.1-23.14c-1.14-1.38-3.12-1.88-4.69-1.02-2.12,1.16-2.57,3.87-1.11,5.63l16.95,20.53c.55.67-.31,1.56-1,1.04-.24-.19-.52-.45-.84-.8l-20.59-22.47c-1.48-1.62-4-1.73-5.62-.24l-.08.07c-1.68,1.54-1.79,4.12-.26,5.78,5.76,6.24,20.76,22.58,20.53,22.32-.29-.32.53.68.68,1.09.22.6.73,1.99-1.19.83l-20.83-19.68c-1.24-1.17-3.2-1.24-4.45-.09-1.79,1.64-1.78,4.42-.05,6.05,6.88,6.5,23.2,21.92,23.2,21.92l1.6,1.51s.01.01.03.04c1.04,1.21-.52,2.92-1.83,2.02l-17.34-11.91c-1.54-1.06-3.64-.67-4.7.87h0c-1.06,1.54-.67,3.64.87,4.7l28.74,19.74,6.83,5.01c.5,1.25,78.1,102.9,78.1,102.9,7.62,9.94,22.01,11.47,31.54,3.34h0c9.4-8.02,14.73-20.58,4.43-32.65Z",
    style: {
      fill: "#d7cfff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.26,348.56l38.75-87.65c1.17-2.64,1.12-5.67-.14-8.27l-11.03-22.78c-.69-1.73-.33-3.63,1.39-4.32,2.53-1.02,4.35,1.02,5.23,2.52,0,0,2.8,5.97,6.4,9.01,2.09,1.76,6.83,1.89,8.96-4.27l7.65-22.68c.46-1.35,1.79-2.29,3.21-2.09,1.91.26,3.01,2.15,2.43,3.88l-6.78,20.12c-.22.65.68,1.08,1.04.49.13-.21.26-.48.4-.84l8.94-22.61c.64-1.63,2.49-2.43,4.12-1.78l.08.03c1.69.67,2.51,2.57,1.84,4.24-2.51,6.29-9.05,22.74-8.94,22.48.13-.32-.2.66-.2,1,0,.51.03,1.69,1.12.28l9.92-20.6c.59-1.22,2.03-1.84,3.29-1.33,1.8.71,2.59,2.78,1.76,4.5-3.28,6.8-11.05,22.94-11.05,22.94l-.76,1.58s0,.01-.01.04c-.43,1.2,1.22,2.03,1.94.98l9.53-13.81c.85-1.23,2.53-1.53,3.75-.69h0c1.23.85,1.53,2.52.69,3.75l-15.8,22.9-3.66,5.68c-.02,1.08-28.91,98.92-28.91,98.92-2.85,9.58-13.14,14.81-22.55,11.47h0c-9.29-3.3-16.83-11.15-12.6-23.07Z",
    style: {
      fill: "#d7cfff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.81,362.81l12.93-81.5c.39-2.46-.32-4.97-1.94-6.85l-14.2-16.53c-.96-1.29-1.08-2.95.21-3.91,1.88-1.4,3.84-.11,4.91.95,0,0,3.64,4.35,7.31,6.09,2.13,1.01,6.11.07,6.52-5.53l1.36-20.57c.08-1.23.99-2.3,2.21-2.45,1.64-.2,2.98,1.13,2.88,2.69l-1.21,18.25c-.04.59.8.75.98.18.06-.2.11-.46.15-.78l2.46-20.79c.18-1.5,1.54-2.57,3.04-2.39h.07c1.55.19,2.65,1.59,2.46,3.13-.71,5.79-2.52,20.92-2.49,20.68.03-.29-.02.59.06.88.12.42.39,1.4.99-.02l3.72-19.33c.22-1.15,1.28-1.98,2.45-1.84,1.65.2,2.77,1.75,2.46,3.35-1.23,6.39-4.14,21.54-4.14,21.54l-.28,1.48s0,.01,0,.03c-.09,1.09,1.46,1.42,1.83.39l4.89-13.6c.43-1.21,1.76-1.83,2.97-1.4h0c1.21.43,1.83,1.76,1.4,2.97l-8.1,22.54-1.8,5.54c.22.9-2.25,88.72-2.25,88.72-.26,8.6-7.67,15.23-16.25,14.52h0c-8.46-.7-16.47-5.57-15.57-16.43Z",
    style: {
      fill: "#d7cfff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.02,153.37c.06-.3.06-.59.01-.88-.74-4.28-13.21-5.7-27.85-3.17-14.64,2.54-25.9,8.06-25.16,12.35l-.16.03,3.22,18.58c.74,4.28,13.21,5.7,27.85,3.17,14.64-2.54,25.9-8.06,25.16-12.35l-3.07-17.73Z",
    style: {
      fill: "#9b80ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.21,165.1c-8.68,0-12.88-1.81-13.19-3.59-.55-3.2,9.74-8.66,24.34-11.19,4.7-.81,9.36-1.24,13.5-1.24,8.69,0,12.89,1.81,13.2,3.59.21,1.2-1.33,3.34-6.27,5.76-4.67,2.29-11.09,4.22-18.08,5.43-4.7.81-9.36,1.24-13.5,1.24h0Z",
    style: {
      fill: "#fff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M213.86,150.07c8.78,0,12.06,1.9,12.21,2.77.3,1.73-7.34,7.23-23.53,10.04-4.64.8-9.25,1.23-13.33,1.23-8.78,0-12.06-1.9-12.21-2.77-.3-1.73,7.34-7.23,23.53-10.04,4.64-.8,9.25-1.23,13.33-1.23M213.86,148.07c-4.07,0-8.74.41-13.67,1.26-14.64,2.54-25.9,8.06-25.16,12.35.49,2.84,6.15,4.42,14.18,4.42,4.07,0,8.74-.41,13.67-1.26,14.64-2.54,25.9-8.06,25.16-12.35-.49-2.84-6.15-4.42-14.18-4.42h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M153.38,158.64l40.99-23.81c1.8-1.04,3.91-1.41,5.95-1.03l46.61,8.63c1.67.31,2.07,2.53.6,3.39l-40.87,24.19c-1.83,1.08-3.99,1.46-6.08,1.05l-46.62-9.03c-1.67-.32-2.05-2.54-.57-3.4Z",
    style: {
      fill: "#d7cfff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.35 151.66 225.29 138.43 228.05 138.94 202.44 152.94 201.35 151.66",
    style: {
      fill: "#b8aeff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.11,132.61l-20.76,19.05,1.09,1.29,21.44-19.5c2.47-1.3,5.98-11.63,5.48-14.38l-.47-12.42-1.79.3.5,11.22c.58,4.08-2.98,13.14-5.49,14.45Z",
    style: {
      fill: "#2d1977"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.56,97.92h3.82v10.46c0,.83-.68,1.51-1.51,1.51h-.81c-.83,0-1.51-.68-1.51-1.51v-10.46h0Z",
    transform: "translate(24.41 -42.23) rotate(11.15)",
    style: {
      fill: "#b8aeff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.45,88.02l62.77,7.35c2.06.24,3.97,1.21,5.38,2.74l42.84,46.46c1.15,1.25.14,3.26-1.55,3.08l-65.55-7.13c-.45-.05-.86-.26-1.16-.59l-44.3-48.84c-1.14-1.26-.11-3.26,1.58-3.07Z",
    style: {
      fill: "#9b80ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.32,139.35c2.54-4.98-9.19-16.03-26.19-24.69-17-8.66-32.84-11.65-35.37-6.68l-11.19,21.49,61.57,31.37,10.5-20.6c.29-.26.52-.56.69-.89Z",
    style: {
      fill: "#d7cfff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 309.35,
    cy: 145.15,
    rx: 10.11,
    ry: 34.55,
    transform: "translate(39.58 354.89) rotate(-63)",
    style: {
      fill: "#2d1977"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.61,125.62l.53.3c.54.31,1.05.67,1.51,1.09,2.26,2.11,3.22,4.37,1.57,8.87l-12.84,30.46,2.16.85,13.13-31.98c1.36-3.32.42-7.14-2.34-9.44,0,0-4.41-3.7-7.67-4.77l3.95,4.61Z",
    style: {
      fill: "#2d1977"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.4,162.55h1.03c1.07,0,1.94.87,1.94,1.94v13.44h-4.91v-13.44c0-1.07.87-1.94,1.94-1.94Z",
    transform: "translate(87.03 -117.27) rotate(21.53)",
    style: {
      fill: "#b8aeff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.68,101.99c.96.12,32.3,10.12,48.22,26.04,13.5,13.5,14.46,23.14,14.46,23.14l8.51-17.42-37.56-30.33-33.64-1.44Z",
    style: {
      fill: "#b8aeff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M113.92,71.27l.76.17c.78.17,1.57.28,2.36.27,3.96-.04,6.81-1.37,9.13-7.04l14.09-39.91,2.79,1.06-15.13,41.6c-1.57,4.32-5.76,7.12-10.35,6.92,0,0-7.36-.3-11.37-2.1l7.71-.97Z",
    style: {
      fill: "#2d1977"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.32,147.57l48.94-67.27c1.22-1.68,3.01-2.87,5.03-3.35l80.95-19.17c1.66-.39,2.91,1.48,1.92,2.86l-50.02,69.95c-.26.37-.65.62-1.09.72l-83.84,19.13c-1.66.38-2.9-1.5-1.9-2.88Z",
    style: {
      fill: "#9b80ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.44,86.2c-3.96-5.95-23.66.19-44,13.73-20.34,13.53-33.61,29.33-29.65,35.28l16.96,25.97,73.65-49.01-16.4-24.64c-.11-.48-.3-.93-.56-1.33Z",
    style: {
      fill: "#d7cfff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.57,
    cy: 136.68,
    rx: 44.23,
    ry: 12.95,
    transform: "translate(-56.36 86.92) rotate(-33.64)",
    style: {
      fill: "#2d1977"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-1)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.02,79.32s.08.06.04.08c-2.78,1.94-37.47,20.16-56.76,49.09-10.55,15.83-6.75,30.86-6.75,30.86l-20.57-25.24,50.3-52.87,33.74-1.92Z",
    style: {
      fill: "#b8aeff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M140.05,10.83h6.29v17.29c0,1.32-1.07,2.4-2.4,2.4h-1.5c-1.32,0-2.4-1.07-2.4-2.4V10.83h0Z",
    transform: "translate(16.65 -49.45) rotate(20.78)",
    style: {
      fill: "#b8aeff"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.70ac74e01f76a44ecb07b94d1e6ecbbb.svg";
export { ForwardRef as ReactComponent };